import {Component, Inject} from 'ng-metadata/core';
import {getVid} from '../appConfig/appConfigForward';
import {SearchFieldsService} from '../search/search.fields.service';
import {SearchStateService} from '../search/searchState.service';
import {SearchService} from '../search/search.service';
import {STATE_NAMES} from '../primoExplore/primoExploreStates.module';
import {NewspapersService} from "./newspapers.service";

@Component({
    selector: 'prm-back-to-library-search',
    templateUrl: 'components/newspapers/back-to-library-search.html',
})

export class PrmBackToLibrarySearch{
    private vid = getVid();

    constructor(@Inject('$location') private $location: ng.ILocationService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private searchFieldsService: SearchFieldsService,
                private searchStateService:  SearchStateService,
                private searchService: SearchService,
                private newspapersService: NewspapersService) {
    }

    private backToSearch(){
        this.resetSearchParams();
        this.newspapersService.cameFromSearch = false;
        this.newspapersService.cameFromFeaturedSearch = false;
        this.newspapersService.featuredTitle = '';
        this.newspapersService.featuredDescription = '';
        this.$state.go(STATE_NAMES.SEARCH,{vid:this.vid}, {inherit:false, reload: true})
    }

    private resetSearchParams(){
        this.searchFieldsService.reset();
        this.searchStateService.resetSearchObject();
        this.searchService.restSignInAlertMessage();
    }


}


// WEBPACK FOOTER //
// ./src/main/webapp/components/newspapers/backToLibrarySearch.directive.ts